import React from "react";
import classNames from "classnames";
import css from "./Divide.module.css";

export const Divide = ({ vertical = false, className = undefined }) => (
    <div className={classNames(css.divide, { [css.vertical]: vertical }, className)} />
);
